export default __webpack_public_path__ + "static/media/video_icon.90108550.svg";